import { useEffect, useState } from "react";
import { getCategoryMaster } from "../functions/deducation";
import { useDispatch } from "react-redux";
import {
  hideLoadingAction,
  showLoadingAction,
} from "../reducks/loading/actions";

function getCategoryIds(products) {
  console.log("products_", products);
  const categoryIds = products.map((product) => product.category);
  return Array.from(new Set(categoryIds));
}

export const useCategoryMaster = (products, billingUserId, billingUserName) => {
  const [categoryMaster, setCategoryMaster] = useState([]);
  const [categoryIds, setCategoryIds] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    const ids = getCategoryIds(products);
    setCategoryIds(ids);
  }, [products.length]);
  useEffect(() => {
    const fetchHistory = async () => {
      dispatch(showLoadingAction("計算中..."));
      const result = await getCategoryMaster(categoryIds);

      setCategoryMaster(result);
      dispatch(hideLoadingAction());
    };
    if (categoryIds?.length && billingUserId && billingUserName) {
      fetchHistory();
    } else {
      setCategoryMaster([]);
    }
  }, [categoryIds, billingUserId, billingUserName, dispatch]);
  // }, []);
  return { categoryMaster };
};
